/* Guia de tamanhos da Edith York. Substitui a Kiwi Sizing.
   Faz quatro coisas que a app nao fazia:
     1. destaca a linha do tamanho que o cliente tem escolhido;
     2. apaga as linhas de tamanhos que esta peca nao vende;
     3. converte cm <-> in sem recarregar;
     4. recomenda o tamanho a partir das medidas e selecciona-o na ficha. */
(function () {
  'use strict';

  var CM_IN = 2.54;

  /* "2XL (Almost sold out)" -> "2XL" ; "Medium" -> "M" ; "37 EU" -> "37" */
  function normaliza(v) {
    if (v == null) return '';
    var s = String(v).replace(/\s*\(.*?\)\s*/g, '').trim();
    s = s.replace(/\s*EU\s*$/i, '').replace(/^\s*EU\s*/i, '').trim();
    /* "35 EU / 3 US / 2.5 UK" (Emil e Bram) -> "35" */
    var eu = s.match(/^(\d+(?:[.,]\d+)?)\s*EU\b/i);
    if (eu) return String(parseFloat(eu[1].replace(',', '.')));
    var mapa = { SMALL: 'S', MEDIUM: 'M', LARGE: 'L', XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL' };
    var u = s.toUpperCase();
    if (mapa[u]) return mapa[u];
    if (/^\d+(\.\d+)?$/.test(s)) return String(parseFloat(s));
    return u;
  }

  function arred(n, casas) {
    var f = Math.pow(10, casas);
    return Math.round(n * f) / f;
  }

  function Guia(raiz) {
    this.raiz = raiz;
    /* os textos vem do Liquid, para o mesmo ficheiro servir as lojas em EN, DE e NL */
    this.t = {
      sel:    raiz.getAttribute('data-t-sel')    || 'Your selection: {s}',
      uma:    raiz.getAttribute('data-t-uma')    || 'Based on one measurement. Add the others for a surer answer.',
      todas:  raiz.getAttribute('data-t-todas')  || 'Fits all the measurements you entered.',
      pe:     raiz.getAttribute('data-t-pe')     || 'Closest fit for the foot length you entered.',
      acima:  raiz.getAttribute('data-t-acima')  || 'Your measurements are above our largest size. {s} is the biggest we carry for this item.',
      escolher: raiz.getAttribute('data-t-escolher') || 'Choose size {s}'
    };
    this.unidade = 'cm';
    this.linhas = [].slice.call(raiz.querySelectorAll('tbody tr'));
    this.secao = raiz.closest('[data-section-id]') || document;
    this.chart = raiz.getAttribute('data-chart');
    this.disponiveis = (raiz.getAttribute('data-size-values') || '')
      .split('|').map(normaliza).filter(Boolean);
    this.ligar();
    this.marcarDisponiveis();
    this.sincronizar();
  }

  Guia.prototype.ligar = function () {
    var self = this;

    this.raiz.addEventListener('click', function (e) {
      if (e.target.closest('[data-eysc-close]')) { self.fechar(); return; }

      var aba = e.target.closest('[data-eysc-tab]');
      if (aba) { self.abrirAba(aba.getAttribute('data-eysc-tab')); return; }

      var u = e.target.closest('[data-eysc-unit]');
      if (u) { self.trocarUnidade(u.getAttribute('data-eysc-unit')); return; }

      var esc = e.target.closest('[data-eysc-escolher]');
      if (esc) { self.escolherTamanho(esc.getAttribute('data-tam')); return; }
    });

    this.raiz.addEventListener('input', function (e) {
      if (e.target.matches('[data-eysc-campo]')) self.calcular();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.raiz.hidden) self.fechar();
    });
  };

  /* as linhas de tamanhos que esta peca nao vende ficam apagadas, para o cliente
     nao escolher um tamanho que nao existe */
  Guia.prototype.marcarDisponiveis = function () {
    if (!this.disponiveis.length) return;
    var disp = this.disponiveis;
    this.linhas.forEach(function (tr) {
      var s = normaliza(tr.getAttribute('data-size'));
      if (disp.indexOf(s) === -1) tr.classList.add('is-fora');
    });
  };

  /* qual o tamanho escolhido agora na ficha */
  Guia.prototype.tamanhoEscolhido = function () {
    var nome = (this.raiz.getAttribute('data-size-option') || '').toLowerCase();
    var inputs = document.querySelectorAll('input[data-variant-input]:checked');
    for (var i = 0; i < inputs.length; i++) {
      var n = (inputs[i].getAttribute('name') || '').toLowerCase();
      if (n === nome || n.indexOf('size') > -1 || n.indexOf('tama') > -1) {
        return normaliza(inputs[i].value);
      }
    }
    return null;
  };

  Guia.prototype.sincronizar = function () {
    var self = this;
    var alvo = this.tamanhoEscolhido();
    var dica = this.raiz.querySelector('[data-eysc-dica]');
    var achou = false;
    this.linhas.forEach(function (tr) {
      var bate = alvo && normaliza(tr.getAttribute('data-size')) === alvo;
      tr.classList.toggle('is-escolhido', !!bate);
      if (bate) achou = true;
    });
    if (dica) {
      if (achou) {
        dica.textContent = self.t.sel.replace('{s}', alvo);
        dica.hidden = false;
      } else {
        dica.hidden = true;
      }
    }
  };

  Guia.prototype.abrir = function () {
    this.sincronizar();
    this.raiz.hidden = false;
    document.documentElement.classList.add('ey-sc-aberto');
    document.body.classList.add('ey-sc-aberto');
    var x = this.raiz.querySelector('.ey-sc__x');
    if (x) x.focus();
  };

  Guia.prototype.fechar = function () {
    this.raiz.hidden = true;
    document.documentElement.classList.remove('ey-sc-aberto');
    document.body.classList.remove('ey-sc-aberto');
    var t = document.querySelector('[data-eysc-open="' + this.raiz.id + '"]');
    if (t) t.focus();
  };

  Guia.prototype.abrirAba = function (nome) {
    this.raiz.querySelectorAll('[data-eysc-tab]').forEach(function (b) {
      var on = b.getAttribute('data-eysc-tab') === nome;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.raiz.querySelectorAll('[data-eysc-painel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-eysc-painel') !== nome;
    });
  };

  Guia.prototype.trocarUnidade = function (u) {
    if (u === this.unidade) return;
    this.unidade = u;
    this.raiz.querySelectorAll('[data-eysc-unit]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-eysc-unit') === u);
    });
    this.raiz.querySelectorAll('[data-cm]').forEach(function (td) {
      var cm = parseFloat(td.getAttribute('data-cm'));
      if (isNaN(cm)) return;
      td.textContent = u === 'in' ? arred(cm / CM_IN, 1) : arred(cm, 1);
    });
    this.raiz.querySelectorAll('[data-eysc-un]').forEach(function (e) { e.textContent = u; });
    this.calcular();
  };

  /* mede cada linha e escolhe a mais pequena que serve */
  Guia.prototype.calcular = function () {
    var self = this;
    var campos = [].slice.call(this.raiz.querySelectorAll('[data-eysc-campo]'));
    var cabec = [].slice.call(this.raiz.querySelectorAll('thead th'))
      .map(function (th) { return (th.querySelector('.ey-sc__th') || th).textContent.trim().toLowerCase(); });

    var querem = {};
    campos.forEach(function (c) {
      var v = parseFloat(c.value);
      if (!isNaN(v) && v > 0) {
        querem[c.getAttribute('data-eysc-campo')] = self.unidade === 'in' ? v * CM_IN : v;
      }
    });

    var saida = this.raiz.querySelector('[data-eysc-saida]');
    var elTam = this.raiz.querySelector('[data-eysc-tam]');
    var elNota = this.raiz.querySelector('[data-eysc-nota]');
    var elBtn = this.raiz.querySelector('[data-eysc-escolher]');
    var chaves = Object.keys(querem);

    if (!chaves.length) { if (saida) saida.hidden = true; return; }

    /* indice da coluna de cada medida */
    /* a coluna diz quem e' por data-field; adivinhar pelo texto do cabecalho parte-se
       assim que a loja nao e' em ingles ("Oberweite", "Bovenwijdte"). */
    var cols = {};
    [].slice.call(this.raiz.querySelectorAll('thead th')).forEach(function (th, i) {
      var f = th.getAttribute('data-field');
      if (f) cols[f] = i;
    });
    if (!Object.keys(cols).length) {
      cabec.forEach(function (h, i) {
        if (h.indexOf('bust') > -1 || h.indexOf('chest') > -1) cols.bust = i;
        else if (h.indexOf('waist') > -1) cols.waist = i;
        else if (h.indexOf('hip') > -1) cols.hip = i;
        else if (h.indexOf('foot') > -1) cols.foot = i;
      });
    }

    var melhor = null;
    this.linhas.forEach(function (tr) {
      if (tr.classList.contains('is-fora')) return;
      var celulas = [].slice.call(tr.children);
      var serve = true, folga = 0;
      chaves.forEach(function (k) {
        var i = cols[k];
        if (i == null || !celulas[i]) { serve = false; return; }
        var cm = parseFloat(celulas[i].getAttribute('data-cm'));
        if (isNaN(cm)) { serve = false; return; }
        if (cm < querem[k]) serve = false;
        folga += cm - querem[k];
      });
      if (serve && melhor === null) melhor = { tr: tr, folga: folga };
    });

    if (!melhor) {
      /* acima da maior linha: nao se promete o que nao ha */
      var ultimas = this.linhas.filter(function (tr) { return !tr.classList.contains('is-fora'); });
      var ultima = ultimas[ultimas.length - 1];
      if (saida) saida.hidden = false;
      if (elTam) elTam.textContent = ultima ? ultima.getAttribute('data-size') : '—';
      if (elNota) elNota.textContent = ultima
        ? self.t.acima.replace('{s}', ultima.getAttribute('data-size'))
        : self.t.acima.replace('{s}', '—');
      if (elBtn) elBtn.hidden = true;
      return;
    }

    var tam = melhor.tr.getAttribute('data-size');
    if (saida) saida.hidden = false;
    if (elTam) elTam.textContent = tam;

    var nota = this.chart === 'shoes'
      ? self.t.pe
      : (chaves.length === 1 ? self.t.uma : self.t.todas);
    if (elNota) elNota.textContent = nota;

    if (elBtn) {
      var temNaFicha = this.disponiveis.indexOf(normaliza(tam)) > -1;
      elBtn.hidden = !temNaFicha;
      elBtn.textContent = self.t.escolher.replace('{s}', tam);
      elBtn.setAttribute('data-tam', tam);
    }

    this.linhas.forEach(function (tr) {
      tr.classList.toggle('is-escolhido', tr === melhor.tr);
    });
  };

  /* clica mesmo no selector da ficha, para o cliente nao ter de o fazer */
  Guia.prototype.escolherTamanho = function (tam) {
    if (!tam) return;
    var alvo = normaliza(tam);
    var inputs = document.querySelectorAll('input[data-variant-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (normaliza(inputs[i].value) === alvo) {
        var lab = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(inputs[i].id) : inputs[i].id) + '"]');
        if (lab) { lab.click(); } else { inputs[i].click(); }
        break;
      }
    }
    var self = this;
    setTimeout(function () { self.fechar(); }, 180);
  };

  /* ---------- arranque ---------- */
  var guias = [];

  function montar() {
    document.querySelectorAll('[data-eysc]').forEach(function (el) {
      if (el.__eysc) return;
      el.__eysc = new Guia(el);
      guias.push(el.__eysc);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-eysc-open]');
    if (!t) return;
    e.preventDefault();
    montar();
    var el = document.getElementById(t.getAttribute('data-eysc-open'));
    if (el && el.__eysc) el.__eysc.abrir();
  });

  /* a ficha redesenha-se por AJAX ao trocar de variante */
  function resync() {
    guias.forEach(function (g) {
      if (document.body.contains(g.raiz)) g.sincronizar();
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input[data-variant-input]')) setTimeout(resync, 60);
  });
  ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (n) {
    document.addEventListener(n, function () { setTimeout(resync, 60); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }
})();
